<template>
	{{ count }}
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		props: {
			item: {
				type: Object,
			},
			page_config: {
				type: String,
			}
		},
		data() {
			return {
				count: this.item.count,
				client: false,
				index: false,
				index_source: false,
				search_params: {},
				searchObject: {
					hitsPerPage: 12,
					facets: [],
					facetFilters: [],
					sortFacetValuesBy: 'count'
				},
			}
		},
		created() {
			this.search_config = JSON.parse(this.page_config).search_config;
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index_source = (this.$config.test_env) ? this.search_config.algolia_test_indexes : this.search_config.algolia_indexes;

			// Reset Stuff
			this.resetVariables();

			this.processItemSearchParams();
			this.performCoreSearch();
		},
		methods: {
			resetVariables() {
				// console.log("Running reset variables");
				this.search_params.searchRadius = 25;
				this.search_params.hits_per_page = this.search_config.hits_per_page;
				this.search_params.page = 1;

				this.search_params.global_facets = [];
				this.search_params.global_toggle_facets = [];

				if (this.search_config.use_search) {
					this.search_params.searchTerm = '';
				}
				if (this.search_config.use_geo) {
					this.search_params.searchGeo = null;
				}

				// Add the list of facets to our default search object.
				this.search_config.facets.forEach((facet) => {
					this.searchObject.facets.push(facet.name);

					if (facet.type == "checkbox") {
						this.search_params.global_facets[facet.name] = [];
					}
					if (facet.type == "toggle") {
						this.search_params.global_toggle_facets[facet.name] = false;
					}
				});
				this.facet_info = _.cloneDeep(this.search_config.facets);

				// console.log("Resetting facet_info",this.facet_info);

				this.search_params.ordering = this.index_source[0].index;
				this.setAlgoliaIndex();
			},
			setAlgoliaIndex() {
				let index_name = this.search_params.ordering;
				this.index = this.client.initIndex(index_name);
			},
			processItemSearchParams() {
				let qVal = this.item.query;
				let aVal = this.item.id;

				//console.log("Value of q is:",qVal);
				//console.log("Value of a is:",aVal);

				if (qVal !== undefined) {
					let query_string = decodeURIComponent(qVal);

					let search_params = new URLSearchParams(query_string);


					// Reset our salary ranges, in case they're not overwritten by values in the url.
					this.search_params.salaryMin = this.search_params.salaryMinRange;
					this.search_params.salaryMax = this.search_params.salaryMaxRange;

					// Do the same for dates.
					this.search_params.date_min = this.search_params.date_base_min;
					this.search_params.date_max = this.search_params.date_base_max;

					// Reset the toggle facets
					this.search_config.facets.filter((facet) => {
						return facet.type == 'toggle';
					}).forEach((facet) => {
						this.search_params.global_toggle_facets[facet.name] = false;
					});

					for (var pair of search_params.entries()) {
						var key = pair[0];
						var value = pair[1].replace("~", "&").replace("¶", "%"); // Don't process the commas just yet.

						//console.log("# " + key + ', ' + value);

						let facet_checkboxes = this.search_config.facets.filter((facet) => {
							return facet.type == 'checkbox' || facet.type == 'range';
						})

						// Loop over the facets
						facet_checkboxes.forEach((facet) => {
							if (key == facet.name) {
								this.search_params.global_facets[facet.name] = value.split("·");
							}
						})

						// Loop over the toggle facets
						let facet_toggles = this.search_config.facets.filter((facet) => {
							return facet.type == 'toggle';
						})
						facet_toggles.forEach((facet) => {
							if (key == facet.name) {
								this.search_params.global_toggle_facets[facet.name] = true;
							}
						})

						if (key == "query") {
							this.search_params.searchTerm = value.replace("^", ",");
						}

						if (key == "salary") {
							var value_range = value.split(",");
							this.search_params.salaryMin = parseInt(value_range[0]);
							this.search_params.salaryMax = parseInt(value_range[1]);
						}

						if (key == "location") {
							var value_range = value.split(",");
							this.search_params.searchRadius = parseInt(value_range[0]);
							this.search_params.searchGeo = { 'lat': value_range[1], 'lng': value_range[2], 'address': value_range[3].replace("^", ",") }
						}

						if (key == "page") {
							this.search_params.page = parseInt(value);
							console.log("Setting page number from url params.", value, this.search_params.page);
						}

						if (key == "order") {
							if (value !== 'undefined') {
								this.search_params.ordering = value;
								this.setAlgoliaIndex();
							}
						}

						if (key == "date") {
							var value_range = value.split(",");
							this.search_params.date_min = parseInt(value_range[0]);
							this.search_params.date_max = parseInt(value_range[1]);
						}
					}
				}
				//console.log("search_params after alert job count processing", this.search_params);
			},
			performCoreSearch() {
				this.index
					.search('', this.getSearchObject(false, false))
					.then((results) => {
						console.log("alert job count we got initial hits:",results.hits,results.nbHits);
						this.count = results.nbHits;
					});
			},
			// Clone our searchObject, so that we can apply our default forced filters without affecting our in memory version.
			getSearchObject(cleanFacets, facet_focus) {
				// Clone our defaults
				var sObj_Clone = _.cloneDeep(this.searchObject);

				if (facet_focus) {
					sObj_Clone.facets = [facet_focus];
				}
				// console.log("Looking for Facets",sObj_Clone.facets)

				// Have this set as default.
				sObj_Clone.numericFilters = [];

				if (!cleanFacets) {
					sObj_Clone = this.buildNormalFacets(sObj_Clone, facet_focus);

					sObj_Clone = this.buildToggleFacets(sObj_Clone);

					sObj_Clone = this.buildHitsPerPage(sObj_Clone);

					sObj_Clone = this.buildNumericFilters(sObj_Clone);

					sObj_Clone = this.buildGeoSearch(sObj_Clone);
				}

				// If there are any permanent facets required add those in.
				sObj_Clone.facetFilters = sObj_Clone.facetFilters.concat(this.search_config.core_facets);

				if (this.search_config.use_numeric_core_filters === true) {
					sObj_Clone.numericFilters = sObj_Clone.numericFilters.concat(this.search_config.core_numeric_filters);
				}

				// console.log("searchObject(cloned) is:",sObj_Clone);
				return sObj_Clone;
			},

			buildNormalFacets(sObj, facet_focus) {
				//global_facets
				for (const [facet_name, facet_group] of Object.entries(this.search_params.global_facets)) {
					if (facet_name !== facet_focus || facet_focus == false) {
						if (facet_group.length > 0) {

							var tmp_array = [];
							facet_group.forEach((facet_option) => {
								tmp_array.push(facet_name + ":" + facet_option);
							})
							sObj.facetFilters.push(tmp_array);
						}
					}
				}
				return sObj;
			},

			buildToggleFacets(sObj) {
				// global_toggle_facets
				for (const [facet_name, facet_group] of Object.entries(this.search_params.global_toggle_facets)) {
					if (facet_group == true) {
						sObj.facetFilters.push([facet_name + ":true"]);
					}
				};
				return sObj;
			},

			buildHitsPerPage(sObj) {
				sObj.hitsPerPage = this.search_params.hits_per_page * this.search_params.page;
				return sObj;
			},

			buildNumericFilters(sObj) {
				// If the values are at max range then actually don't apply any filter to Algolia so it includes salaries with no value set
				if (this.search_config.use_salary_fields) {

					if (this.search_params.salaryMin !== this.search_params.salaryMinRange || this.search_params.salaryMax !== this.search_params.salaryMaxRange) {
						sObj.numericFilters.push('salary-low:' + this.search_params.salaryMin + ' TO ' + this.search_params.salaryMax);
					}
				}

				if (this.search_config.use_date_fields) {
					if (this.search_params.date_min !== undefined && this.search_params.date_max !== undefined) {
						if (this.search_params.date_min !== this.search_params.date_base_min || this.search_params.date_max !== this.search_params.date_base_max) {
							var date1 = new Date(this.search_params.date_min);
							var date2 = new Date(this.search_params.date_max);
							//console.log(date1.toLocaleString('en-GB', { timeZone: 'UTC' }), date2.toLocaleString('en-GB', { timeZone: 'UTC' }));

							sObj.numericFilters.push(this.search_params.date_field + ':' + this.search_params.date_min + ' TO ' + this.search_params.date_max);
							sObj.facets.push(this.search_params.date_field);
						}
					}
				}
				return sObj;
			},

			buildGeoSearch(sObj) {
				if (this.search_config.use_geo) {
					if (this.search_params.searchGeo !== null) {
						sObj.aroundLatLng = [this.search_params.searchGeo.lat, this.search_params.searchGeo.lng].join(",");
						sObj.aroundRadius = (this.search_params.searchRadius * 1000) // km
					}
				}
				return sObj
			},
		}
	}
</script>
